import { getSavedSoundEnabled, saveSoundEnabled } from "../state/storage";

let audioContext: AudioContext | null = null;

export function getAudioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AudioCtx =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioContext || audioContext.state === "closed") {
    try {
      audioContext = new AudioCtx();
    } catch {
      return null;
    }
  }
  return audioContext;
}

export function resetAudioContextForTesting(): void {
  audioContext = null;
}

export function getSoundEnabled(): boolean {
  return getSavedSoundEnabled();
}

export function setSoundEnabled(enabled: boolean): void {
  saveSoundEnabled(enabled);
}

/**
 * Synthesizes a crisp, short confirmation beep via Web Audio API.
 * Safely degrades without throwing in unsupported or suspended audio environments.
 */
export function playScanSuccessBeep(): void {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    if (ctx.state === "suspended") {
      ctx.resume().catch(() => {});
    }

    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    // Crisp rising chime tone: 1400 Hz -> 1800 Hz over ~40ms
    osc.frequency.setValueAtTime(1400, now);
    osc.frequency.exponentialRampToValueAtTime(1800, now + 0.04);

    // Fast attack to prevent pop, short sustain, exponential decay
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.linearRampToValueAtTime(0.2, now + 0.008);
    gain.gain.setValueAtTime(0.2, now + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + 0.1);
  } catch {
    // Safe degradation: never throw to caller
  }
}
